import React from "react";
import Tray from "../Video";

const FitnessMoreInfoTray = props => {
  return (
    <div className="netflix-tray">
      <Tray
        {...props}
        showCount={false}
        netflix={true}
        hideCategories={true}
        showProgressBar={false}
        showDetailsBottom={true}
        showPlayIcon={true}
        draggable={false}
        neouTrayTitle={true}
      />
    </div>
  );
};

export default FitnessMoreInfoTray;
